/**
 * RecentlyAddedReportsPage
 *
 * Reports added within the last 7 days. The "created after" cutoff is applied
 * by the reports context's fetchPage based on the "recently-added" sidebar
 * option; the page itself is a standard table view.
 */

import ReportsShell from "@/components/reports/ReportsShell"
import ReportsTable, { buildReportFilterOptions } from "@/components/reports/ReportsTable"
import { useReportsPage, ReportsPage } from "@/components/reports/useReportsPage"
import { FilterOption } from "@/components/shared/TableFiltersSelector"

/** Browser tab title and page heading. */
const PAGE_TITLE: string = "Recently Added"

/** Short description shown under the page heading. */
const PAGE_DESCRIPTION: string = "Browse reports that have been added to our database in the past week"

/**
 * The status filter options. They take no inputs, so they are built once at
 * module load rather than on every render.
 */
const FILTER_OPTIONS: FilterOption[] = buildReportFilterOptions()

/**
 * The Recently Added reports page.
 *
 * @returns The rendered page element.
 */
export default function RecentlyAddedReportsPage(): React.JSX.Element {
  const page: ReportsPage = useReportsPage({ sidebarOption: "recently-added" })

  return (
    <ReportsShell title={PAGE_TITLE} description={PAGE_DESCRIPTION} showDetailsPanel>
      <ReportsTable page={page} filterOptions={FILTER_OPTIONS} visibleColumns={page.visibleColumns} />
    </ReportsShell>
  )
}
